import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormErrorAlertComponent, ToastsComponent, MyLoaderComponent } from './components';
import { HrefExternalUrlDirective } from './directives/href-external-url.directive';
import { ClickOutsideDirective } from './directives/click-outside.directive';
import { MyCurrencyPipe } from './pipes/my-currency.pipe';

@NgModule({
  declarations: [
    FormErrorAlertComponent,
    ToastsComponent,
    HrefExternalUrlDirective,
    ClickOutsideDirective,
    MyCurrencyPipe,
    MyLoaderComponent,
  ],
  imports: [
    CommonModule
  ],
  exports: [
    FormErrorAlertComponent,
    ToastsComponent,
    HrefExternalUrlDirective,
    ClickOutsideDirective,
    MyLoaderComponent,
  ]
})
export class CoreModule { }
